import dayjs from "dayjs";
import { API_BASE_URL } from "../data_lib/apiConfig";

//////////////////// GLOBALES ///////////////////////////
export async function fetchGlobalCardData(filtersObj) {
  try {
    const formattedStartDate = dayjs(filtersObj.start_date).format("YYYY-MM-DD");
    const formattedEndDate = dayjs(filtersObj.end_date).format("YYYY-MM-DD");

    const url = `${API_BASE_URL}/data_exposure/get-store-general-data`;

    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        store_id: filtersObj.store_id,
        age_ranges_ids: filtersObj.age_ranges,
        start_date: formattedStartDate,
        end_date: formattedEndDate,
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    // console.log("Global card data", data);

    return data;
  } catch (error) {
    if (error.name === "AbortError") {
      //console.log("Fetch aborted");
    } else {
      console.error("Error fetching campaign cards data", error);
    }
    throw error;
  }
}
export async function fetchGlobalSegmentacionData(filtersObj) {
  try {
    const formattedStartDate = dayjs(filtersObj.start_date).format("YYYY-MM-DD");
    const formattedEndDate = dayjs(filtersObj.end_date).format("YYYY-MM-DD");

    const url = `${API_BASE_URL}/data_exposure/get-store-data`;

    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        store_id: filtersObj.store_id,
        age_ranges_ids: filtersObj.age_ranges,
        start_date: formattedStartDate,
        end_date: formattedEndDate,
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    // console.log("Global card data", data);

    return data;
  } catch (error) {
    if (error.name === "AbortError") {
      //console.log("Fetch aborted");
    } else {
      console.error("Error fetching campaign cards data", error);
    }
    throw error;
  }
}
export async function fetchGlobalWatchersTimeData(filtersObj) {
  try {
    const formattedStartDate = dayjs(filtersObj.start_date).format("YYYY-MM-DD");
    const formattedEndDate = dayjs(filtersObj.end_date).format("YYYY-MM-DD");

    const url = `${API_BASE_URL}/data_exposure/get-store-watchers-vs-attention-time-data`;

    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        store_id: filtersObj.store_id,
        age_ranges_ids: filtersObj.age_ranges,
        start_date: formattedStartDate,
        end_date: formattedEndDate,
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    // console.log("Global card data", data);

    return data;
  } catch (error) {
    if (error.name === "AbortError") {
      //console.log("Fetch aborted");
    } else {
      console.error("Error fetching campaign cards data", error);
    }
    throw error;
  }
}
//////////////////////// POR CAMARA //////////////////////
export async function fetchCardInfo(filtersObj) {
  try {
    const formattedStartDate = dayjs(filtersObj.start_date).format("YYYY-MM-DD");
    const formattedEndDate = dayjs(filtersObj.end_date).format("YYYY-MM-DD");

    // console.log(
    //   JSON.stringify({
    //     camera_id: filtersObj.camera_id,
    //     age_ranges_ids: filtersObj.age_ranges,
    //     start_date: formattedStartDate,
    //     end_date: formattedEndDate,
    //   })
    // );

    const url = `${API_BASE_URL}/data_exposure/get-camera-cards-data`;

    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        camera_id: filtersObj.camera_id,
        age_ranges_ids: filtersObj.age_ranges,
        start_date: formattedStartDate,
        end_date: formattedEndDate,
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();

    return data;
  } catch (error) {
    if (error.name === "AbortError") {
      //console.log("Fetch aborted");
    } else {
      console.error("Error fetching campaign cards data", error);
    }
    throw error;
  }
}

//////////////////////////////////////////////
export async function fetchSegmentationData(filtersObj) {
  try {
    const formattedStartDate = dayjs(filtersObj.start_date).format("YYYY-MM-DD");
    const formattedEndDate = dayjs(filtersObj.end_date).format("YYYY-MM-DD");

    // console.log(
    //   JSON.stringify({
    //     camera_id: filtersObj.camera_id,
    //     age_ranges_ids: filtersObj.age_ranges,
    //     start_date: formattedStartDate,
    //     end_date: formattedEndDate,
    //   })
    // );

    const url = `${API_BASE_URL}/data_exposure/get-camera-data`;

    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        camera_id: filtersObj.camera_id,
        age_ranges_ids: filtersObj.age_ranges,
        start_date: formattedStartDate,
        end_date: formattedEndDate,
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();

    return data;
  } catch (error) {
    if (error.name === "AbortError") {
      //console.log("Fetch aborted");
    } else {
      console.error("Error fetching campaign cards data", error);
    }
    throw error;
  }
}
//////////////////////////////////////////////
export async function fetchWatchersTimeData(filtersObj) {
  try {
    const formattedStartDate = dayjs(filtersObj.start_date).format("YYYY-MM-DD");
    const formattedEndDate = dayjs(filtersObj.end_date).format("YYYY-MM-DD");

    // console.log(
    //   JSON.stringify({
    //     camera_id: filtersObj.camera_id,
    //     age_ranges_ids: filtersObj.age_ranges,
    //     start_date: formattedStartDate,
    //     end_date: formattedEndDate,
    //   })
    // );

    const url = `${API_BASE_URL}/data_exposure/get-watchers-vs-attention-time-data`;

    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        camera_id: filtersObj.camera_id,
        age_ranges_ids: filtersObj.age_ranges,
        start_date: formattedStartDate,
        end_date: formattedEndDate,
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();

    return data;
  } catch (error) {
    if (error.name === "AbortError") {
      //console.log("Fetch aborted");
    } else {
      console.error("Error fetching campaign cards data", error);
    }
    throw error;
  }
}
